import Container from '@components/global/Container';
import Heading from '@components/ui/Heading';
import Button from '@components/ui/Button';
import IconWrapper from '@components/ui/Icons';
import { FeaturedBestSellersSlice } from '@adapters/prismic/types/brandedStorePage';
import CompareBar from '_components/CompareBar';
import ProductCardAlt from '@components/product/ProductCollectionComponent/ProductCardAlt';
import { AlgonomyProduct } from '@components/global/Recommendations/Loader';

import styles from './FeaturedBestSellers.module.scss';

export const FeaturedBestSellers = ({
  primary,
  locale,
  products,
}: FeaturedBestSellersSlice) => {
  const { title, cta_title, cta_link } = primary;

  return (
    <Container>
      {title && (
        <div className={styles.headingContainer}>
          <Heading semanticLevel="h3" styleLevel="1" className={styles.heading}>
            {title}
          </Heading>
          <IconWrapper
            classNames={styles.icon}
            icon="best-sellers"
            width={40}
            height={40}
          />
        </div>
      )}
      <div className={styles.productsContainer}>
        {products &&
          products?.map((product: AlgonomyProduct) => (
            <ProductCardAlt
              displayName={product.displayName}
              displayPrice={product.displayPrice}
              productImage={product.imageURL}
              productUrl={product?.linkURL ?? product?.detailURL}
              salePrice={product.displaySalePrice}
            />
          ))}
      </div>
      {cta_title && cta_link && (
        <Container className={styles.buttonContainer}>
          <Button
            className={styles.cta}
            label={cta_title}
            size="large"
            type="button"
            href={`/${locale}/${cta_link}`}
          />
        </Container>
      )}
      <CompareBar />
    </Container>
  );
};

export default FeaturedBestSellers;
